import { IProps } from '@/Interfaces/Icons/Props.interface';

const ChangeLogHistoryIcon = ({ className, ...props }: IProps) => {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 6C10 5.44772 10.4477 5 11 5H21C21.5522 5 22 5.44772 22 6C22 6.55229 21.5522 7 21 7H11C10.4477 7 10 6.55228 10 6Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 12C10 11.4477 10.4477 11 11 11H21C21.5522 11 22 11.4477 22 12C22 12.5523 21.5522 13 21 13H11C10.4477 13 10 12.5523 10 12Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 18C10 17.4477 10.4477 17 11 17H21C21.5522 17 22 17.4477 22 18C22 18.5523 21.5522 19 21 19H11C10.4477 19 10 18.5523 10 18Z'
        fill='currentColor'
      />
      <path
        d='M8.84811 3.47013C9.14082 3.93847 8.99845 4.55542 8.53011 4.84813C7.75692 5.33138 6.98454 6.3867 6.36836 7.46502C6.07342 7.98116 5.83636 8.46252 5.67314 8.81493C5.61083 8.94769 5.4842 9.24118 5.42867 9.37133C5.2836 9.7337 4.94076 9.97901 4.55093 9.99884C4.16099 10.0187 3.79517 9.80976 3.61412 9.46384C3.44089 9.13283 3.16067 8.82288 2.89218 8.58028C2.78725 8.48167 2.55615 8.30602 2.45371 8.23052C1.99132 7.92886 1.86086 7.3095 2.16236 6.84694C2.46394 6.38426 3.08349 6.25366 3.54616 6.55524C3.68236 6.64701 4.01826 6.89088 4.27235 7.13214C4.38104 6.92332 4.50119 6.70143 4.63187 6.47274C5.26569 5.36357 6.24331 3.91889 7.47012 3.15214C7.93845 2.85943 8.5554 3.0018 8.84811 3.47013Z'
        fill='currentColor'
      />
      <path
        d='M8.84811 14.4701C9.14082 14.9385 8.99845 15.5554 8.53011 15.8481C7.75692 16.3314 6.98454 17.3867 6.36836 18.465C6.07342 18.9812 5.83636 19.4625 5.67314 19.8149C5.61083 19.9477 5.4842 20.2412 5.42867 20.3713C5.2836 20.7337 4.94076 20.979 4.55093 20.9988C4.16099 21.0187 3.79517 20.8098 3.61412 20.4638C3.44089 20.1328 3.16067 19.8229 2.89218 19.5803C2.78725 19.4817 2.55615 19.306 2.45371 19.2305C1.99132 18.9289 1.86086 18.3095 2.16236 17.8469C2.46394 17.3843 3.08349 17.2537 3.54616 17.5552C3.68236 17.647 4.01826 17.8909 4.27235 18.1321C4.38104 17.9233 4.50119 17.7014 4.63187 17.4727C5.26569 16.3636 6.24331 14.9189 7.47012 14.1521C7.93845 13.8594 8.5554 14.0018 8.84811 14.4701Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ChangeLogHistoryIcon;
